import { BadRequestError } from "./base.error.js";
import { FoundationErrorMessages } from "../constants/foundation-errors.constants.js";

export class InvalidNormalizedValueError extends BadRequestError {
  constructor(
    public readonly typeName: string,
    public readonly invalidValue: number,
  ) {
    super(
      FoundationErrorMessages.invalidNormalizedValue(typeName, invalidValue),
    );
    Object.defineProperty(this, "name", {
      value: "InvalidNormalizedValueError",
    });
  }
}
